import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanMatch, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {CookieService} from "ngx-cookie-service";
import {AuthService} from "../services/auth.service";
import appConfig from '../config/app-config';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanMatch {

  public sso_signed: any = this.cookieService.get('sso_signed');

  constructor(private router: Router, private cookieService: CookieService, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const currentUser = this.authService.currentUserValue;
    const token = this.authService.getToken;
    const redirectTo = route.queryParams['redirectTo'];

    if (token) {

      if (redirectTo) {
        // Redirect to the URL specified in the redirectTo query parameter
        return window.location.href = redirectTo;
      }

      if (/^\/(login|register)/.test(state.url)) {
        window.location.href = appConfig.vettimesUrl;
        return false;
      }

      if (state.url.startsWith('/admin')) {
        // Allow 'User' role only for /admin/analytics-dashboard
        if (currentUser.role === 'Admin') {
          return true;
        }
        if (currentUser.role === 'Analytics' && state.url === '/admin/analytics-dashboard') {
          return true;
        }
        return this.router.parseUrl('/');
      }

      return true;
    }

    if (['/admin'].some(url => state.url.startsWith(url))) {
      return this.router.parseUrl('/login');
    }

    return true;
  }


  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canDeactivate(component: unknown, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canMatch(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
}